document.addEventListener("alpine:init", () => {
  Alpine.data("CtrProductBox", () => ({
    mode: "subscribe",
    selectedVariant: null,
    fallbackSellingPlanId: null,
    mainProduct: {},
    subscriptionDataObj: { selling_plans: [] },
    selectedSellingPlanId: null,
    loading: false,
    variantMediaMap: {},
    sectionId: null,
    giftVariants: [],
    giftPropertyKey: '_offer',
    giftPropertyValue: 'free-gifts',
    insuredShippingVariant: null,
    redirectAfterAdd: 'checkout',

    init() {
      this.mode = this.$el.dataset.defaultMode || "subscribe";
      this.selectedVariant = this.parseNullableInt(
        this.$el.dataset.initialVariantId
      );
      this.fallbackSellingPlanId = this.parseNullableInt(
        this.$el.dataset.fallbackSellingPlanId
      );
      this.sectionId = this.$el.dataset.sectionId || null;
      this.giftVariants = (this.$el.dataset.giftVariants || '')
        .split(',')
        .map(v => v.trim())
        .filter(v => v !== '');
      this.giftPropertyKey = this.$el.dataset.giftPropertyKey || '_offer';
      this.giftPropertyValue = this.$el.dataset.giftPropertyValue || 'free-gifts';
      this.insuredShippingVariant = this.parseNullableInt(this.$el.dataset.insuredShippingVariant);
      this.redirectAfterAdd = this.$el.dataset.redirectAfterAdd || 'checkout';

      this.parseVariantMediaMap();
      this.parseRechargeProduct();
      this.getRechargeData();
      this.setSellingPlanForVariant(this.selectedVariant);
       // Fix: reset loading state when navigating back from checkout (bfcache)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) this.loading = false;
  });
    },

    parseNullableInt(value) {
      if (value === undefined || value === null || value === "") return null;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    },

    parseRechargeProduct() {
      const rawJson = this.$refs.rechargeProductJson?.textContent;
      if (!rawJson) {
        this.mainProduct = {};
        return;
      }
      try {
        this.mainProduct = JSON.parse(rawJson);
      } catch (error) {
        console.error("[ctr-pb] recharge product parse error", error);
        this.mainProduct = {};
      }
    },

    getRechargeData() {
      const groups = (this.mainProduct.selling_plan_groups || []).filter(
        (g) => String(g.app_id) === "294517"
      );

      const allPlans = groups.flatMap((g) =>
        Array.isArray(g.selling_plans) ? g.selling_plans : []
      );

      const normalized = [];
      const seen = new Set();

      for (const plan of allPlans) {
        if (!plan || seen.has(plan.id)) continue;
        seen.add(plan.id);

        const adjustment = plan.price_adjustments?.[0] || {};
        normalized.push({
          id: plan.id,
          name: plan.name,
          discount: adjustment.value || 0,
          discount_type: adjustment.value_type || "",
          fixed_price:
            adjustment.value_type === "price" ? adjustment.value : null,
        });
      }

      this.subscriptionDataObj = { selling_plans: normalized };
    },

    setSellingPlanForVariant(variantId) {
      const plans = this.subscriptionDataObj?.selling_plans || [];
      if (!plans.length) {
        this.selectedSellingPlanId = this.fallbackSellingPlanId;
        return;
      }

      const variant = (this.mainProduct.variants || []).find(
        (item) => item.id === variantId
      );
      const allocationPlanId =
        variant?.selling_plan_allocations?.[0]?.selling_plan_id;
      const matchedPlan = plans.find((plan) => plan.id === allocationPlanId);

      if (matchedPlan) {
        this.selectedSellingPlanId = matchedPlan.id;
        return;
      }

      const fallbackMatched = plans.find(
        (plan) => plan.id === this.fallbackSellingPlanId
      );
      this.selectedSellingPlanId = fallbackMatched
        ? fallbackMatched.id
        : plans[0].id;
    },

    parseVariantMediaMap() {
      const rawJson = this.$refs.variantMediaMap?.textContent;
      if (!rawJson) return;
      try {
        this.variantMediaMap = JSON.parse(rawJson);
      } catch (e) {
        this.variantMediaMap = {};
      }
    },

    slideToVariantImage(variantId) {
      if (!this.sectionId) return;
      const mediaId = this.variantMediaMap[String(variantId)];
      if (!mediaId) return;

      const mainEl = document.querySelector("#ctr-pb-main-" + this.sectionId);
      if (!mainEl || !mainEl.swiper) return;

      const slides = Array.from(mainEl.querySelectorAll(".swiper-slide"));
      const targetIndex = slides.findIndex(
        (slide) => slide.dataset.mediaId === String(mediaId)
      );

      if (targetIndex !== -1) {
        mainEl.swiper.slideTo(targetIndex);
      }
    },

    onVariantChange(variantId) {
      this.selectedVariant = variantId;
      this.setSellingPlanForVariant(variantId);
      this.slideToVariantImage(variantId);
    },

    addToCart() {
      if (!this.selectedVariant || this.loading) return;

      this.loading = true;

      const t0 = performance.now();
      const log = (label) => console.log(`[ctr-pb] ${label}: +${Math.round(performance.now() - t0)}ms`);
      log('click');

      const mainItem = { id: this.selectedVariant, quantity: 1 };
      if (this.mode === "subscribe" && this.selectedSellingPlanId) {
        mainItem.selling_plan = this.selectedSellingPlanId;
      }

      const items = [mainItem];
      if (this.mode === "subscribe") {
        const giftPropKey = this.giftPropertyKey;
        const giftPropValue = this.giftPropertyValue;
        this.giftVariants.forEach(function(variantId) {
          const props = {};
          props[giftPropKey] = giftPropValue;
          items.push({
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: props
          });
        });
      }

      if (this.insuredShippingVariant) {
        items.push({
          id: this.insuredShippingVariant,
          quantity: 1,
          properties: { '_insured_shipping': 'true' }
        });
      }

      fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .then(function(r) { log('clear done'); return r.json(); })
        .then(() => {
          log('add start');
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: items }),
          });
        })
        .then(function(r) { log('add done'); return r.json(); })
        .then(() => {
          log('redirect');
          // Fire ATC event for paid product only
          const variant = (this.mainProduct.variants || []).find(v => v.id === this.selectedVariant);
          if (variant && window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish('custom_add_to_cart', {
              variantId: String(this.selectedVariant),
              productTitle: this.mainProduct.title || '',
              price: (variant.price / 100).toFixed(2),
              currency: window.Shopify?.currency?.active || 'USD',
              quantity: 1
            });
            console.log('[ctr-pb] ATC published for:', this.mainProduct.title);
          }

          if (this.redirectAfterAdd === 'checkout') window.location.href = '/checkout';
          else if (this.redirectAfterAdd === 'cart') window.location.href = '/cart';
          else this.loading = false;
        })
        .catch((error) => {
          console.error("[ctr-pb] cart error", error);
          this.loading = false;
        });
    },
  }));
});
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    const section = document.getElementById('ctr-pb-template--20255796560046__ctr_product_box_7b6ezE');
    if (section) {
      const top = section.getBoundingClientRect().top + window.scrollY - 93;
      window.scrollTo({ top: top, behavior: 'instant' });
    }
  }
});
